import { useState } from "react";
import { Box, Button } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import nodata from '../../Images/nodata.png'
import { useDispatch, useSelector } from "react-redux";
import { getUserDetail } from "../../Actions/UserDetailAction";
import { getUserBankList, selectedUserBankList } from "../../Actions/UserBankListAction";


function BankDetailList() {
    const navigate = useNavigate();
    const { userDetailData, userDetailStatus } = useSelector((state) => state.user);
    const [userDetail, setUserDetail] = useState({})
    const dispatch = useDispatch();
    const { bankListData } = useSelector((state) => state.userBank); // from reducer
    const [bankList, setBankList] = useState([])

    useEffect(() => {
        if (userDetailStatus === true) {
            setUserDetail(userDetailData?.result)
        }
    }, [userDetailStatus])

    useEffect(() => {
        if (!userDetailData) {
            dispatch(getUserDetail());
        }

        if (bankList?.length === 0) {
            // dispatch(getUserBanks());
        }
    }, []);

    useEffect(() => {
        if (!bankListData) {
            dispatch(getUserBankList())
        }
    }, [])

    useEffect(() => {
        if (bankListData) {
            setBankList(bankListData?.result)
        }
        else {
            setBankList([])
        }

    }, [bankListData])

    const handleDelete = () => {
        // dispatch(deleteUserBank(bankId));
    };

    return (
        <div className="Kyc">
            <div className="card-box-heading">
                <h1><span className="clr-grd">Bank Details</span></h1>
            </div>


            <Box component="main" sx={{ marginTop: "50px", margin: "0 auto", }}>
                <Grid container spacing={2} className="card-box">
                    {bankList.length > 0 &&
                        <>
                            <Grid item size={{ xs: 12, sm: 8, md: 8, lg: 8, xl: 8 }}  >
                                <Box sx={{ padding: 1, borderRadius: 2, }} >
                                    <h3 style={{ color: '#fff', marginBottom: 8 }}>Bank Details</h3>
                                </Box>
                            </Grid>

                            {bankList.length <= 5 &&
                                <Grid item size={{ xs: 12, sm: 4, md: 4, lg: 4, xl: 4 }} >
                                    <div className="blu-btn text-end mt-15">
                                        <Button variant="contained" onClick={() => navigate('/add-bank-details')}>
                                            Add Bank Account
                                        </Button>
                                    </div>
                                </Grid>
                            }
                        </>
                    }
                    {bankList?.length == 0 ?
                        <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} >
                            <div className="display-3">
                                <div className="text-center">
                                    <img src={nodata} style={{ height: 200, width: 200 }} />
                                    <p >You Don't have bank details</p>

                                    <div className="blu-btn text-center mt-20">
                                        <Button onClick={() => navigate('/add-bank-details')} >Add Bank account</Button>
                                    </div>
                                </div>
                            </div>
                        </Grid>
                        :
                        (bankList?.map((item) => (
                            <Grid item size={{ xs: 12, sm: 6, md: 12, lg: 6, xl: 4 }} className="mt-20" >
                                <div className="card-box-border bk-details" style={{ height: '100%' }}>
                                    <Grid container className="inner" spacing={2} sx={{ height: '100%' }}>
                                        <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}  >
                                            <div className="display-2">
                                                <h3 style={{ whiteSpace: "nowrap" }}>A/c number : </h3>
                                                <p style={{ wordBreak: "break-all" }}>{item.accountNumber}</p>
                                            </div>
                                        </Grid>
                                        <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}  >
                                            <div className="display-2">
                                                <h3>IFSC Code :</h3>
                                                <p>{item.ifscCode ? item?.ifscCode : '-'}</p>
                                            </div>
                                        </Grid>
                                        <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}  >
                                            <div className="display-2">
                                                <h3>Bank Name :</h3>
                                                <p>{item.bankName}</p>
                                            </div>
                                        </Grid>



                                        <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}  >
                                            <div className="display-2">
                                                <h3>Account Holder Name :</h3>
                                                <p>{item.accountHolderName}</p>
                                            </div>
                                        </Grid>


                                        <Grid item size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }}  >
                                            <div className="blu-btn display-3 mt-20">
                                                <Button onClick={() => handleDelete(item.bankId)} fullWidth>Delete</Button>
                                            </div>
                                        </Grid>
                                        <Grid item size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }}  >
                                            <div className="blu-btn display-3 mt-20">
                                                <Button onClick={() => {
                                                    dispatch(selectedUserBankList(item));
                                                    navigate("/edit-bank-detail", { state: { bankData: item } })
                                                }} fullWidth>Edit</Button>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </div>
                            </Grid>
                        ))

                        )
                    }
                </Grid>
            </Box>

        </div>
    );
}

export default BankDetailList;
